import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { projectsApi } from '../../../utils'
import Moment from 'moment';
import classes from './NewProject.module.css'
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import { onKeyDown } from "../../../service";
import { ObjectTypeEnumText } from "../../../models/ObjectTypeEnum";
import Loader from "../../lms-shared/UI/Loader/Loader";

const NewProject = ({ studyGroupId, closePopup, addNewProject }) => {
    const texts = useSelector(state => state.translate.texts);
    const uiData = useSelector((state) => state.general.uiData);
    const [newProject, setNewProject] = useState({ id: null, name: null, isAllowed: false })
    const [ides, setIdes] = useState()
    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (uiData) {
            setIdes(uiData.ides)
        }
    }, [uiData])

    const changeNewProject = (key, val) => {
        setNewProject((prevNewProject) => {
            let newNewProject = { ...prevNewProject }
            newNewProject[key] = val
            if (newNewProject.id && newNewProject.name) {
                newNewProject.isAllowed = true
                return newNewProject
            } else {
                newNewProject.isAllowed = false
                return newNewProject
            }
        })
    }

    const createNewProject = () => {
        setLoader(true)
        if (newProject.isAllowed) {
            const data = {
                name: newProject.name,
                description: null,
                ideId: newProject.id,
                refObjectType: ObjectTypeEnumText.StudyGroup,
                refObjectId: studyGroupId
            }
            projectsApi.projectsAddPost({ "projectAddInput": data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.projectsAddError, error: error, statusCode: response?.statusCode, message: "projectsAddPost " + error.message, level: 2, component: "NewProject", line: 44 }))
                } else {
                    addNewProject()
                }
                setLoader(false)
            })
        }
    }

    return (
        <div className={classes.NewProjectWrapper}>
            {loader ? <Loader /> : <div className={classes.NewProject}>
                <div className={classes.Circle} onClick={(e) => closePopup(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => closePopup(e))}>
                    <div className={classes.XLine}></div>
                    <div className={`${classes.XLine} ${classes.Rotate}`}></div>
                </div>
                <div className={classes.Title}>{texts.createNewProject}</div>
                <div className={classes.ChooseIDE}>{texts.chooseIDE}</div>
                {uiData && <div className={classes.IDEs}>
                    {ides && ides.map((ide, i) =>
                        <div className={`${classes.IDEWrapper} ${newProject.id && newProject.id === ide.id && classes.Chosen}`} onClick={() => changeNewProject("id", ide.id)} key={i} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeNewProject("id", ide.id))}>
                            <img className={classes.IDEContent} src={ide.icon} alt="IdeIcon" />
                        </div>
                    )}
                </div>}
                <input type='text' placeholder={texts.giveNewName} name="newProjectName" className={classes.NewNameInput} onChange={(e) => changeNewProject("name", e.target.value)} ></input>
                <div className={classes.CreateBtn} onClick={createNewProject} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, createNewProject)} style={{ cursor: newProject.isAllowed ? "pointer" : "not-allowed" }}>{texts.create}</div>
            </div>}
        </div>
    )
}
export default NewProject